import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-barchart-vertical-loader',
  templateUrl: './barchart-vertical-loader.component.html',
  styleUrls: ['./barchart-vertical-loader.component.css']
})
export class BarchartVerticalLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
